
import axios from "axios";
import { API_ENDPOINT } from "@/utils/misc";

export const history = (jobFilterId, week) => {
  return axios.get(`${API_ENDPOINT()}/schedules/history`, {
    params: { jobFilterId, week }
  });
};
